import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { HOME } from "@/constants/testIds";
import Education360App from "@/education360/App";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div>
      <header className="App-header">
        <a
          data-testid={HOME.emergentLink}
          className="App-link"
          href="https://emergent.sh"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4" />
        </a>
        <p className="mt-5">Building something incredible ~!</p>
      </header>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Preview root now boots directly into Education360 so users
              are not left on a static placeholder. THOM360 Home is
              preserved verbatim at /thom360 and the THOM360 API root
              (/api/) remains untouched. */}
          <Route path="/" element={<Navigate to="/education360" replace />} />
          <Route path="/thom360" element={<Home />} />
          {/* Education360 — independent education platform */}
          <Route path="/education360/*" element={<Education360App />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
